var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTimelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.5H10.5V20.5H19.5V10.75H17.25V8.5ZM10.5 7H18L21 10V20.5C21 20.8978 20.842 21.2794 20.5607 21.5607C20.2794 21.842 19.8978 22 19.5 22H10.5C10.1022 22 9.72064 21.842 9.43934 21.5607C9.15804 21.2794 9 20.8978 9 20.5V8.5C9 8.10218 9.15804 7.72064 9.43934 7.43934C9.72064 7.15804 10.1022 7 10.5 7ZM12 13.75H18V15.25H12V13.75ZM12 16.75H18V18.25H12V16.75Z",
    fill: "#979797"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14,
    stroke: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimelineIcon);
export default __webpack_public_path__ + "static/media/ic_timeline_icon.b09c0518e3b3f5f635daa481249744c0.svg";
export { ForwardRef as ReactComponent };